import { createSlice } from '@reduxjs/toolkit';
import { Nullable } from '@jamesgmarks/utilities';
import { TCurrencyCode } from '@llws/hydra-shared';
import { TLoadedState, TSaveState } from 'src/types/TLoadedState';

interface IInvoicePreviewData {
  invoiceNumber: string;
  address: {
    organization?: string;
    street?: string;
    street2?: string;
    city?: string;
    province?: string;
    country?: string;
    postalCode?: string;
  };
  items: {
    item: string;
    description: string;
    unitCost: number;
    quantity: number;
    lineTotal: number;
  }[];
  taxTotal: number;
  total: number;
  currency: TCurrencyCode
};

export interface IInvoicePreviewState {
  previewData: Nullable<IInvoicePreviewData[]>;
  loadedState: TLoadedState;
  invoiceGroupSaveState: TSaveState
}

const initialState: IInvoicePreviewState = {
  previewData: null,
  loadedState: 'idle',
  invoiceGroupSaveState: 'idle',
};

export const invoiceManagementSlice = createSlice({
  name: 'invoiceManagementSlice',
  initialState,
  reducers: {
    invoicePreviewReceived: (state, action) => {
      state.previewData = action.payload.data;
      state.loadedState = 'loaded';
    },
    setLoadedState: (state, action) => {
      state.loadedState = action.payload;
    },
    setInvoiceGroupSaveState: (state, action) => {
      state.invoiceGroupSaveState = action.payload;
    },
    clearPreviewData: (state) => {
      state.previewData = null;
      state.loadedState = 'idle';
    },
  },
});

export const {
  invoicePreviewReceived,
  setLoadedState,
  setInvoiceGroupSaveState,
  clearPreviewData,
} = invoiceManagementSlice.actions;

export default invoiceManagementSlice.reducer;
